export default {
  computed : {
    flashMessage(){
      return this.$store.state.flashMessage.parameters;
    }
  },

  methods : {
    handleFlashMessageClose(){
      this.$store.dispatch('flashMessage/clearFlashMessage', {root:true});
    }
  },

  // // for test
  // mounted(){
  //   setTimeout(() => {
  //     this.$store.dispatch({
  //       type        : 'flashMessage/updateFlashMessage',
  //       hasMessage  : true,
  //       message     : 'フラッシュメッセージです。',
  //       status      : 'default',
  //       hasControl  : true,
  //       autoClose   : false
  //     }, {root:true});
  //   }, 1000);
  // }
}